// extracted by mini-css-extract-plugin
export var rightPanelOpenOld = "_8z-0";